export const ReportTypes = {
  ExecutiveRiskOverview: "executive-risk-overview",
  ResidualVsTargetRiskTrend: "residual-vs-target-risk-trend",
  RiskScoreCube: "risk-score-cube",
  RiskOwnershipByRole: "risk-ownership-by-role",
  RiskOwnershipByModel: "risk-ownership-by-model",
  RiskOwnershipByField: "risk-ownership-by-field",
  RiskTreatmentOverview: "risk-treatment-overview",
  ComplianceDashboard: "compliance-dashboard",
  ControlComplianceByDomain: "control-compliance-by-domain",
  ControlMaturityByDomain: "control-maturity-by-domain",
  ControlComplianceAndMaturityTrend: "control-compliance-and-maturity-trend",
  RiskScoreSankey: "risk-score-sankey",
  UserRiskComparison: "user-risk-comparison",
  ControlAttributesOverview: "control-attributes-overview",
  FindingRemediationTracker: "finding-remediation-tracker",
  RiskLeaderboardOverview: "risk-leaderboard-overview",
  DeploymentTargetPortfolio: "deployment-target-portfolio",
  DeploymentTargetComplianceOverview: "deployment-target-compliance-overview",
  ComplianceOwnershipByUser: "compliance-ownership-by-user",
  ComplianceOwnershipByItem: "compliance-ownership-by-item",
};
